<app-side-menu>
  <div class="portal-access-content">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <button class="btn-back" (click)="navigateBack()">
                <i class="fas fa-arrow-left"></i>
              </button>
              <h1 class="page-title">
                <i class="fas fa-user-shield me-3"></i>
                Usuários e acessos do portal
              </h1>
              <p class="page-subtitle" *ngIf="contractNumber">
                Contrato: {{ contractNumber }} - {{ contractName }}
              </p>
            </div>
            <div *ngIf="tab === 'users'">
              <app-button
                *appHasPermission="'B2BContracts.Edit'"
                text="Novo usuário"
                color="var(--success-color)"
                height="40px"
                (buttonClick)="newUser()">
                <i class="fas fa-plus me-2"></i>
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs">
      <button type="button" class="tab" [class.active]="tab === 'users'" (click)="setTab('users')">
        Usuários
      </button>
      <button type="button" class="tab" [class.active]="tab === 'access'" (click)="setTab('access')">
        Atribuição de acessos
      </button>
    </div>

    <div class="card-panel" *ngIf="tab === 'users'">
      <div *ngIf="totalItems > 0 || isLoadingUsers || searchTerm || users.length; else emptyUsers">
        <app-table
          [title]="'Usuários do portal (' + totalItems + ')'"
          [data]="users"
          [columns]="columns"
          [loading]="isLoadingUsers"
          [clickable]="false"
          [actions]="actions"
          [showSearch]="true"
          [searchPlaceholder]="'Pesquisar nome, e-mail ou perfil...'"
          [itemsPerPage]="pageSize"
          [totalItemsFromBackend]="totalItems"
          [currentPageFromBackend]="pageNumber"
          [totalPagesFromBackend]="totalPages"
          [disablePagination]="false"
          (searchChange)="onSearchChange($event)"
          (actionClick)="onActionClick($event)"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)">
        </app-table>
      </div>
      <ng-template #emptyUsers>
        <div class="empty-state">
          <i class="fas fa-user-slash"></i>
          <h3>Nenhum usuário do portal</h3>
          <p>Crie o primeiro acesso para este contrato B2B.</p>
        </div>
      </ng-template>
    </div>

    <div class="card-panel" *ngIf="tab === 'access'">
      <div class="alert-auth" *ngIf="accessError">{{ accessError }}</div>

      <div class="access-layout" *ngIf="!isLoadingAccess; else loadingAccess">
        <aside class="roles-list">
          <div class="roles-header">
            <h3>Perfis</h3>
            <button
              type="button"
              class="btn-link"
              *appHasPermission="'B2BContracts.Edit'"
              (click)="openCreateRole()">
              <i class="fas fa-plus"></i> Novo perfil
            </button>
          </div>

          <div class="create-role-box" *ngIf="showCreateRole">
            <label>Código</label>
            <input type="text" [(ngModel)]="newRoleCode" placeholder="EX: OPERADOR_SP" maxlength="40" />
            <label>Nome</label>
            <input type="text" [(ngModel)]="newRoleName" placeholder="Nome do perfil" maxlength="80" />
            <label>Descrição (opcional)</label>
            <input type="text" [(ngModel)]="newRoleDescription" placeholder="Descrição" maxlength="160" />
            <p class="field-error" *ngIf="createRoleError">{{ createRoleError }}</p>
            <div class="create-role-actions">
              <button type="button" class="btn-secondary" (click)="cancelCreateRole()" [disabled]="isCreatingRole">Cancelar</button>
              <button type="button" class="btn-primary" (click)="createRole()" [disabled]="isCreatingRole">
                {{ isCreatingRole ? 'Salvando...' : 'Criar' }}
              </button>
            </div>
          </div>

          <button
            type="button"
            class="role-item"
            *ngFor="let role of roles"
            [class.active]="selectedRoleCode === role.code"
            (click)="selectRole(role.code)">
            <strong>{{ role.name }}</strong>
            <span>
              {{ role.code }} · {{ role.userCount }} usuário(s)
              <em *ngIf="role.isSystem"> · sistema</em>
            </span>
          </button>

          <div class="empty-state compact" *ngIf="!roles.length">
            <p>Nenhum perfil encontrado. Use "Novo perfil" ou rode o seed do Auth B2B.</p>
          </div>
        </aside>

        <section class="permissions-panel" *ngIf="selectedRoleCode">
          <div class="permissions-header">
            <div>
              <h3>Menu e ações liberados</h3>
              <p>
                Marque Views (menu) e ações do perfil <strong>{{ selectedRole?.name || selectedRoleCode }}</strong>.
              </p>
            </div>
            <div class="permissions-actions">
              <button
                type="button"
                class="btn-danger-outline"
                *appHasPermission="'B2BContracts.Edit'"
                [disabled]="!selectedRole || selectedRole.isSystem || selectedRole.userCount > 0"
                (click)="deleteSelectedRole()"
                title="Perfis de sistema ou com usuários não podem ser excluídos">
                <i class="fas fa-trash"></i> Excluir perfil
              </button>
              <app-button
                *appHasPermission="'B2BContracts.Edit'"
                text="Salvar acessos"
                color="var(--primary-color)"
                height="40px"
                [disabled]="isSavingAccess || !accessDirty"
                (buttonClick)="saveRoleAccess()">
                <i class="fas fa-save me-2"></i>
              </app-button>
            </div>
          </div>

          <div
            class="module-block"
            *ngFor="let group of permissionGroups; trackBy: trackByModule">
            <h4>{{ group.module }}</h4>
            <label class="perm-row" *ngFor="let perm of group.items; trackBy: trackByPermissionCode">
              <input
                type="checkbox"
                [checked]="isPermissionChecked(perm.code)"
                (change)="togglePermission(perm.code, $any($event.target).checked)" />
              <span>
                <strong>{{ perm.name }}</strong>
                <small>{{ perm.code }}</small>
              </span>
            </label>
          </div>
        </section>
      </div>
      <ng-template #loadingAccess>
        <div class="empty-state"><i class="fas fa-spinner fa-spin"></i><p>Carregando perfis...</p></div>
      </ng-template>
    </div>
  </div>
</app-side-menu>
